import React, {SFC, useState} from "react";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import { Typography, makeStyles } from "@material-ui/core";

import { PartnerSignUpForm } from "../../../Components/Forms/SignUp";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import { ReactComponent as LogoSVG } from "../../../Images/logo.svg";
import ConfirmEmail from "../../../Components/ConfirmEmail/ConfirmEmail";
const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        marginBottom: 55,
        zIndex: 1,
    },
});

interface Props {
	setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
}

const PartnerSignUp: SFC<Props> = ({setIsOnBoarding}: Props) => {
    const [isEmailConfirmed, setIsEmailConfirmed] = useState(undefined);
    const classes = useStyles();

    return (
        <Container className={classes.containerRoot} maxWidth="sm">
            <Card className={classes.cardRoot}>
                {isEmailConfirmed === false
                    ?
                    <ConfirmEmail/>
                    :
                    <>
                        <Box display="flex" justifyContent="center">
                            <LogoSVG/>
                        </Box>
                        <Box marginTop="20px" marginBottom="8px">
                            <Typography
                                variant="h2"
                                align="center"
                            >
						Get started
                            </Typography>
                        </Box>
                        <Box marginBottom="24px" display="flex" justifyContent="center">
                            <Typography
                                align="center"
                                style={{maxWidth: "270px", fontSize: 18}}
                            >
						Empower your clients to access virtual veterinary care
                            </Typography>
                        </Box>
                        <PartnerSignUpForm setIsOnBoarding={setIsOnBoarding} setIsEmailConfirmed={setIsEmailConfirmed} />
                    </>}
            </Card>
            <Typography align="center" style={{fontSize: "20px"}}>
				Have an account?&nbsp;<Link to="/login/?login=true">Sign In!</Link>
            </Typography>
        </Container>
    );
};

export default PartnerSignUp;
